import { useState } from "react";

export const Settings = () => {
  const [url, setUrl] = useState(localStorage.getItem("url") || "127.0.0.1");
  const [port, setPort] = useState(localStorage.getItem("port") || "81");

  const setLocalPatch = (e, name, func) => {
    func(e.target.value);
    localStorage.setItem(name, e.target.value);
  };

  return (
    <div className="settings_container">
      <div className="connect_container">
        <h1>Настройки подключения</h1>
        <label className="connect_container_row">
          <span>ip подключения</span>
          <input
            className="connect_container_inpt"
            type="text"
            placeholder="127.0.0.1"
            value={url}
            onChange={(e) => setLocalPatch(e, "url", setUrl)}
          />
        </label>
        <label className="connect_container_row">
          <span>порт подключения</span>
          <input
            className="connect_container_inpt"
            type="number"
            placeholder="81"
            value={port}
            onChange={(e) => setLocalPatch(e, "port", setPort)}
          />
        </label>
      </div>
    </div>
  );
};
